
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Plus } from "lucide-react";
import { useOpportunityManagement } from "@/hooks/admin/opportunities";
import OpportunityDialog from "./opportunities/OpportunityDialog";
import OpportunitiesTable from "./opportunities/OpportunitiesTable";

const AdminOpportunities = () => {
  const {
    opportunities,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    isSubmitting,
    isDeleting,
    currentOpportunity,
    handleInputChange,
    handleCreate,
    handleEdit,
    handleSubmit,
    handleDelete,
  } = useOpportunityManagement();

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Opportunities</h2>
        <Button onClick={handleCreate}>
          <Plus className="h-4 w-4 mr-2" />
          Add Opportunity
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <OpportunitiesTable
          opportunities={opportunities}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleting={isDeleting}
        />
      )}

      <OpportunityDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        currentOpportunity={currentOpportunity}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default AdminOpportunities;
